/* eslint-disable react/prop-types */
import {
  Typography, Card, List, ListItem,
} from '@material-ui/core';
import React from 'react';

const CourseObjectivesAndRessources = ({ courseInfos }) => (
  <Card style={{ padding: '15px' }}>
    <Typography variant="subtitle2">Objectifs de la formation: </Typography>
    <List>
      {courseInfos.objectives.map((objective) => (
        <ListItem>
          <Typography variant="body2">{objective.name}</Typography>
        </ListItem>
      ))}
    </List>
    <Typography variant="subtitle2">Ressources pédagogiques utilisées: </Typography>
    {courseInfos.resources.length > 0
      ? (
        <List>
          {courseInfos.resources.map((resource) => (
            <>
              {resource.suggested
            && (
            <ListItem>
              <Typography variant="body2">{resource.name}</Typography>
            </ListItem>
            )}
            </>
          ))}
        </List>
      )
      : (
        <div style={{ marginTop: '15px' }}>
          <Typography variant="body2">A valider avec le formateur lors des premières séances.</Typography>
          <Typography variant="body2">
            Utilisation de supports divers et authentiques
            (presse, journaux économiques et culturels ainsi que podcasts,
            sites internet...)
          </Typography>
        </div>
      )}
  </Card>
);

export default CourseObjectivesAndRessources;
